// Affiliate nội bộ: bắt ?ref= (userId của CTV) trên BẤT KỲ trang nào → lưu localStorage để mọi
// giao dịch mua nội bộ (CAB+/voice/cosmetic) quy công cho người giới thiệu. Hết hạn 30 ngày.
const KEY = 'affRef';
const TS_KEY = 'affRefAt';
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

/** Gọi ở root khi app load: nếu URL có ?ref= thì lưu lại (kèm mốc thời gian). */
export const captureAffRef = () => {
  try {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref && /^[0-9a-fA-F-]{8,}$/.test(ref)) {
      localStorage.setItem(KEY, ref);
      localStorage.setItem(TS_KEY, String(Date.now()));
    }
  } catch {
    /* ignore */
  }
};

/** Ref còn hiệu lực (chưa quá 30 ngày). undefined nếu không có/hết hạn. */
export const getAffRef = (): string | undefined => {
  try {
    const ref = localStorage.getItem(KEY);
    const at = Number(localStorage.getItem(TS_KEY) || '0');
    if (!ref) return undefined;
    if (at && Date.now() - at > MAX_AGE_MS) return undefined;
    return ref;
  } catch {
    return undefined;
  }
};
